import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { getPurchaseReportList } from '@/api/scm/purchase-report';
import moment from "moment";
const today = moment().format('L')
export default extend(table, {
	namespaced: true,
	state: {
		date: '',
		list: [],
		searchForm: {
			time: [`${today} 00:00:00`, `${today} 23:59:59`]
		}
	},
	actions: {
		async getList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'scm.purchase-report.list', async function () {
				const { searchForm } = state;
				const response = await getPurchaseReportList({
					startTime: searchForm.time && moment(moment(searchForm.time[0]).format('YYYY-MM-DD')).valueOf() / 1000,
					endTime: searchForm.time && moment(moment(searchForm.time[1]).format('YYYY-MM-DD')).valueOf() / 1000,
				})
				if (response.data) {
					commit('save', {
						list: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/purchase-report/list.js